import React from 'react';

const Footer: React.FC = () => {
  return (
    <div className="container-fluid footer py-5 wow fadeIn" data-wow-delay="0.1s">
      <div className="container py-5">
        <div className="row g-5">
          <div className="col-md-6 col-lg-4 col-xl-6">
            <div className="footer-item">
              <img src={process.env.PUBLIC_URL + '/img/logo.png'} alt="Alana English Center" height="60" />
              <h4 className="mb-4 fw-bold">Trung tâm Anh ngữ Alana</h4>
            </div>
          </div>
          <div className="col-md-6 col-lg-4 col-xl-6">
            <div className="footer-item">
              <h4 className="text-primary mb-4 border-bottom border-primary border-2 d-inline-block p-2 title-border-radius">Địa chỉ</h4>
              <div className="d-flex flex-column align-items-start">
                <a href="#" className="text-body mb-4">
                  <i className="fa fa-map-marker-alt text-primary me-2"></i>
                  Lô 34-35, phân khúc B2-30, khu tái định cư Hòa Liên 5, Xã Hòa Liên, Huyện Hòa Vang, Thành Phố Đà Nẵng Da Nang, Vietnam
                </a>
                <a href="tel:02367302679" className="text-start rounded-0 text-body mb-4">
                  <i className="fa fa-phone-alt text-primary me-2"></i>0236 7302 679
                </a>
                <a href="mailto:alanaenglishcenter@gmail.com" className="text-start rounded-0 text-body mb-4">
                  <i className="fas fa-envelope text-primary me-2"></i>alanaenglishcenter@gmail.com
                </a>
                <div className="footer-icon d-flex">
                  <a className="btn btn-primary btn-sm-square me-3 rounded-circle text-white" href="https://www.facebook.com/alanaenglishcenter">
                    <i className="fab fa-facebook-f"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer; 